import React from "react";

const documentRequirements = [
  {
    type: "Exam Reschedule Request",
    description: "Request to reschedule an exam due to valid reasons.",
    requirements: [
      "Completed Exam Reschedule Form",
      "Proof of reason (e.g., medical certificate, event invitation)",
      "Student ID card copy",
      "Approval from course instructor (if required)"
    ]
  },
  {
    type: "Exam Re-attempt Request",
    description: "Request to re-attempt an exam you missed or failed.",
    requirements: [
      "Completed Exam Re-attempt Form",
      "Reason for re-attempt (with supporting documents)",
      "Student ID card copy"
    ]
  },
  {
    type: "Lab Reschedule Request",
    description: "Request to reschedule a lab session due to valid reasons.",
    requirements: [
      "Completed Lab Reschedule Form",
      "Proof of reason (e.g., medical certificate, event invitation)",
      "Student ID card copy"
    ]
  },
  {
    type: "Studentship Confirmation Letter",
    description: "Request for an official letter confirming your studentship.",
    requirements: [
      "Request Form",
      "Student ID card copy"
    ]
  },
  {
    type: "Progress Report",
    description: "Request for an official progress report from the university.",
    requirements: [
      "Request Form",
      "Student ID card copy"
    ]
  },
  {
    type: "Student ID Card",
    description: "Request for a new or replacement student ID card.",
    requirements: [
      "Request Form",
      "Proof of loss/damage (if replacement)",
      "Student ID card copy (if available)"
    ]
  },
  {
    type: "Bonafide Certificate",
    description: "Request for a bonafide certificate for various purposes.",
    requirements: [
      "Request Form",
      "Student ID card copy"
    ]
  }
];

const RequirementsPage = () => (
  <div className="Content-Background" style={{ maxWidth: 700, margin: "2rem auto" }}>
    <h2 style={{ textAlign: "center", marginBottom: "2rem" }}>Document Requirements</h2>
    {documentRequirements.map((doc, idx) => (
      <div key={idx} style={{ marginBottom: "2.5rem", padding: "1.5rem", borderRadius: "1rem", background: "#f8fafc", boxShadow: "0 2px 8px rgba(30,64,175,0.06)" }}>
        <h3 style={{ color: "#1e40af", marginBottom: "0.5rem" }}>{doc.type}</h3>
        <p style={{ color: "#334155", marginBottom: "0.75rem" }}>{doc.description}</p>
        <ul>
          {doc.requirements.map((req, i) => (
            <li key={i} style={{ marginBottom: "0.5rem" }}>{req}</li>
          ))}
        </ul>
      </div>
    ))}
  </div>
);

export default RequirementsPage; 